/* global jQuery */
import React from 'react'
import d3 from 'd3'
import selectn from 'selectn'
import * as utils from '../../../lib/utils/common'

// Lookup commonly used team colors
let teamColors = {
  home : '#40b5e5',
  away: '#ef3a49',
  default: '#aaa'
}

/**
 * Update overs comparison data from feed.
 * If an innings does not have values property (array of overs), set to empty
 * array.
 *
 * @param  {Array} data Innings data
 * @return {undefined}      undefined
 */
function setDataForEmptyOvers(data) {
  for (var i = 0; i < data.length; i++) {
    let d = data[i]
    if (d.hasOwnProperty('values') === false) {
      d.values = []
    }
  }
}
/**
 * tooltip position is calculated based on mouse hover co-ordinates.
 * X co-ordinate based on hover X co-ordinate and chart container's median co-ordinates
 * Y co-ordinate based on document height, hover Y co-ordinates, tooltip height
 * @param {Object} div tooltip instance
 * @param {String} mainContainerSelector mainContainer reference
 * @param {String} divSelector Chartcontainer reference
 * @param {Number} width width of chart container
 * @return {undefined} undefined
*/
function getTooltipPosition(div, mainContainerSelector, divSelector, width) {
  let docHeight =parseInt(jQuery(document).height(),10)
  let tooltipHeight = parseInt(div.style('height'),10)
  let tooltipWidth = parseInt(div.style('width'),10)
  let leftPos = 0
  let topPos = 0
  let mainContainerOffset = jQuery(mainContainerSelector).offset()
  let chartContainerOffset = jQuery(divSelector).offset()
  // If hovered position is in left half of chart container tooltip will be leaned towards right and viceversa
  if(d3.event.pageX > parseInt(chartContainerOffset.left + width/2)) {
    leftPos = d3.event.pageX - tooltipWidth - 10
  }
  else { 
    leftPos = d3.event.pageX + 10
  }
  // If sufficient gap (tooltip height) is available between hovered position and end of document, then tooltip will be downwards else upwards
  if((docHeight-d3.event.pageY-20) > tooltipHeight) {
    topPos = d3.event.pageY - parseInt(mainContainerOffset.top,10) + 10    
  }
  else {
    topPos = d3.event.pageY - tooltipHeight - parseInt(mainContainerOffset.top,10) - 10
  }
  return { leftPos, topPos }
}
/**
 * Draw legends for the charts
 * @param  {Array} svg       SVG element
 * @param  {NUmber} width     width of the chart area
 * @param  {String} team1 display name/abbreviation of team 1
 * @param  {String} team2 display name/abbreviation of team 2
 * @param  {Number} inn1Overs Number of overs in 1st innings
 * @param  {Number} inn2Overs Number of overs in 2nd innings
 * @return {undefined} undefined
 */
function drawLegend(svg, width, team1 = {}, team2 = {}, inn1Overs, inn2Overs) {
  // Chart legends
  //console.info('inn1Overs, inn2Overs', inn1Overs, inn2Overs)
  let team1Name = team1.teamName || 'TEAM A'
  let team2Name = team2.teamName || 'TEAM B'
  let team1Color = team1.name === 'home' ? teamColors.home :teamColors.away
  let team2Color = team2.name === 'home' ? teamColors.home : teamColors.away
  // Draw team 1 legend only if team 1 number of overs is positive number
  if (inn1Overs > 0) {
    svg.append('rect')
        .attr('x', width - 180)
        .attr('y', -20)
        .attr('height', 10)
        .attr('width', 10)
        .attr('fill', team1Color)
    svg.append('text')
      .attr('x', width - 180 + 15)
      .attr('y', -20 + 10)
      .text(team1Name)
      .attr('fill', teamColors.default)
  }

  // Draw team 2 legend only if team 2 number of overs is positive number
  if (inn2Overs > 0) {
    svg.append('rect')
      .attr('x', width - 180)
      .attr('y', 5)
      .attr('height', 10)
      .attr('width', 10)
      .attr('fill', team2Color)
    svg.append('text')
        .attr('x', width - 180 + 15)
        .attr('y', 5 + 10)
        .text(team2Name)
        .attr('fill', teamColors.default)
  }

}

function barChart({ divSelector = '#chart-manhattan', div, data } = {}) {

  let inn1Overs = selectn('[0].values.length', data) || 0
  let inn2Overs = selectn('[1].values.length', data) || 0
  const overs = inn1Overs > inn2Overs ? inn1Overs: inn2Overs

  const outerHeight = 375
  const margin = { top: 30, right: 5, bottom: 30, left: 35 }
  const mainContainerSelector = '#main-container'
  const width = jQuery(divSelector).width() - margin.left - margin.right
  const height = outerHeight - margin.top - margin.bottom
  const maxTicks = 25
  const yAxisTicks = 4
  let diameter = 13
  const breakPoint = 1024
  // Extract team names
  const team1 = selectn('[0]', data) || {}
  const team2 = selectn('[1]', data) || {}

  let maxRuns = d3.max(data, function (t) { return d3.max(t.values, function (v) {
    return v.runs
  }) })
  const yMax = Math.ceil(maxRuns/5)*5
  const y = d3.scale.linear()
    .domain([ 0, yMax ])
    .range([ height, margin.top ])

  const x0 = d3.scale.ordinal()
    .domain(d3.range(1, overs+1))
    .rangeBands([ 0, width - margin.right ], .2)

  const x1 = d3.scale.ordinal()
    .domain([ 0, 1 ])
    .rangeBands([ 0, x0.rangeBand() ])

  const xAxis = d3.svg.axis()
    .scale(x0)
    .tickValues(x0.domain().filter(function (d, i) { return overs > maxTicks ? !(i % 5) : true }))
    .orient('bottom')

  const yAxis = d3.svg.axis()
    .scale(y)
    .tickSize(-width + margin.right)
    .ticks(overs < yAxisTicks ? overs : yAxisTicks)
    .orient('left')

  // set circle diameter
  if (x1.rangeBand() < diameter) {
    diameter = x1.rangeBand()

    if (diameter < 6) {
      diameter = 6
    }
  }

  const svg = d3.select(divSelector).append('svg')
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)
    .append('g')
    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

  svg.append('g')
      .attr('class', 'y axis')
      .call(yAxis)

  svg.append('g')
      .attr('class', 'x axis')
      .attr('transform', 'translate(0,' + height + ')')
      .call(xAxis)

  svg.append('g').selectAll('g')
      .data(data)
    .enter().append('g')
      .style('fill', function (d) { return d.name === 'home' ? teamColors.home : teamColors.away })
      .attr('transform', function (d, i) { return 'translate(' + x1(i) + ',0)' })
    .selectAll('g')
      .data(function (d) { return d.values })
    .enter().append('rect')
      .attr('height', function (d) { return height - y(d.runs) })
      .attr('width', x1.rangeBand())
      .attr('x', function (d) { return x0(d.over) })
      .attr('y', function (d) { return y(d.runs) })

  svg.selectAll('dot')
      .data(data)
      .enter()
        .append('g')
        .selectAll('g')
        .data(function (d) { return d.values })
        .enter()
        .append('g')
          .selectAll('g')
          .data(function (d) { return d.wickets })
          .enter()
          .append('circle')
            .attr('r', diameter/2)
            .attr('stroke', function () {
              return d3.select(this.parentNode.parentNode).datum().name === 'home' ? teamColors.home : teamColors.away
            })
            .attr('stroke-width', '2px')
            .attr('fill', 'white')
            .attr('cx', function () {
              const datum = d3.select(this.parentNode.parentNode).datum()
              return x0(d3.select(this.parentNode).datum().over) + (x1.rangeBand()/2) + (datum.name == 'home' ? 0 : x1.rangeBand() )
            })
            .attr('cy', function (d, i) {
              return y(d3.select(this.parentNode).datum().runs) - (diameter/2) - (i * (diameter))
            })
            .on('mouseover', function (d) {
              if (jQuery(window).width() < breakPoint) { return }
              let toolipPosition = {}
              div.html(d.text)
              toolipPosition = getTooltipPosition(div,mainContainerSelector,divSelector,width)
              div.transition()
                .duration(200)
                .style('opacity', .9)
              div.style('left', toolipPosition.leftPos + 'px')
                .style('top', toolipPosition.topPos + 'px')
            })
            .on('mouseout', function () {
              if (jQuery(window).width() < breakPoint) { return }
              div.transition()
                .duration(350)
                .style('opacity', 0)
            })

  svg.append('text')
    .attr('x', (width/2) - 25) // 25 is roughly text elem width/2, to be calc
    .attr('y', height + margin.bottom)
    .text('OVERS')
    .attr('fill', teamColors.default)

  svg.append('text')
      .attr('y', 0 - margin.left + 10 ) // 10 is approx half of label height
      .attr('x', 0 - ((height / 2) + 50 )) // 50 is approx half of label width
      .attr('transform', 'rotate(-90)')
      .text('RUNS PER OVER')
      .attr('fill', teamColors.default)

  drawLegend(svg, width, team1, team2, inn1Overs, inn2Overs)

}

function lineChart({ data, divSelector = '#chart-runrate', keys, div, yLabel = 'RUNS' }) {

  try{

    let inn1Overs = selectn('[0].values.length', data) || 0
    let inn2Overs = selectn('[1].values.length', data) || 0
    const overs = inn1Overs > inn2Overs ? inn1Overs: inn2Overs

    const maxTicks = 10
    const minTicksSpacing = 30
    const yAxisTicks = 4
    const outerHeight = 375
    const mainContainerSelector = '#main-container'
    let diameter = 13
    const breakPoint = 1024
    // Extract team names
    const team1 = selectn('[0]', data) || {}
    const team2 = selectn('[1]', data) || {}

    keys = keys || {
      x : 'over',
      y : 'runs'
    }
    const margin = { top: 30, right: 20, bottom: 30, left: 20 }
    const width = jQuery(divSelector).width() - margin.left - margin.right
    const height = outerHeight - margin.top - margin.bottom

    const x = d3.scale.linear()
      .range([ margin.left, (width - (margin.right)) ])

    const x0 = d3.scale.ordinal()
      .domain(d3.range(1, overs+1))
      .rangeBands([ 0, width - margin.right ], .2)

    const x1 = d3.scale.ordinal()
      .domain([ 0, 1 ])
      .rangeBands([ 0, x0.rangeBand() ])

    const y = d3.scale.linear()
      .range([ height, margin.top ])

    const xAxis = d3.svg.axis()
      .scale(x)
      .ticks((overs > maxTicks) ? Math.floor(width / minTicksSpacing) : overs - 1)
      .orient('bottom')

    const yAxis = d3.svg.axis()
      .scale(y)
      .ticks(yAxisTicks)
      .tickSize(-width + margin.right)
      .tickPadding(10)
      .orient('left')

    // set circle diameter
    if (x1.rangeBand() < diameter) {
      diameter = x1.rangeBand()

      if (diameter < 6) {
        diameter = 6
      }
    }

    const line = d3.svg.line()
      .interpolate('linear')
      .x(function (d) { return x(d[keys.x]) })
      .y(function (d) { return y(d[keys.y]) })

    let svg = d3.select(divSelector).append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

    x.domain([ 1, overs ])

    const yMax = d3.max(data, function (t) { return d3.max(t.values, function (v) {
      return v[keys.y]
    }) })

    y.domain([
      d3.min(data, function (t) { return d3.min(t.values, function (v) { return v[keys.y] }) }),
      yMax
    ])

    yAxis.ticks(yMax < yAxisTicks ? yMax : yAxisTicks)

    svg.append('g')
      .attr('class', 'x axis')
      .attr('transform', 'translate(0,' + height + ')')
      .call(xAxis)

    svg.append('g')
      .attr('class', 'y axis')
      .attr('transform', 'translate(' + margin.left + ',0)')
      .call(yAxis)

    var team = svg.selectAll('.team')
      .data(data)
      .enter()
      .append('g')
      .attr('class', 'team')

    team.append('path')
      .attr('class', 'line')
      .attr('fill', 'transparent')
      .attr('d', function (d) { return line(d.values) })
      .style('stroke', function (d) { return d.name === 'home' ? teamColors.home : teamColors.away })

    svg.selectAll('dot')
      .data(data)
      .enter()
        .append('g')
        .selectAll('g')
        .data(function (d) { return d.values })
        .enter()
        .append('g')
          .selectAll('g')
          .data(function (d) { return d.wickets })
          .enter()
          .append('circle')
            .attr('r', diameter/2)
            .attr('stroke', function () {
              return d3.select(this.parentNode.parentNode).datum().name === 'home' ? teamColors.home : teamColors.away
            })
            .attr('stroke-width', '2px')
            .attr('fill', 'white')
            .attr('cx', function () { return x(d3.select(this.parentNode).datum()[keys.x]) })
            .attr('cy', function (d, i) {
              return y(d3.select(this.parentNode).datum()[keys.y]) + (i * diameter)
            })
            .on('mouseover', function (d) {              
              if (jQuery(window).width() < breakPoint) { return }
              let toolipPosition = {}
              div.html(d.text)
              toolipPosition = getTooltipPosition(div,mainContainerSelector,divSelector,width)
              div.transition()
                .duration(200)
                .style('opacity', .9)
              div.style('left', toolipPosition.leftPos + 'px')
                .style('top', toolipPosition.topPos + 'px')
            })
            .on('mouseout', function () {
              if (jQuery(window).width() < breakPoint) { return }
              div.transition()
                .duration(350)
                .style('opacity', 0)
            })
    svg.append('text')
      .attr('x', (width/2) - 25) // 25 is roughly text elem width/2, to be calc
      .attr('y', height + margin.bottom)
      .text('OVERS')
      .attr('fill', teamColors.default)

    svg.append('text')
        .attr('y', 0 - (margin.left/2) )
        .attr('x', 0 - ((height / 2) + 25 )) // 25 is approx half of label width
        .attr('transform', 'rotate(-90)')
        .text(yLabel)
        .attr('fill', teamColors.default)

    // Chart legends
    drawLegend(svg, width, team1, team2, inn1Overs, inn2Overs)

    return svg

  }catch(e) {
    console.log(e)
  }
}

export class Charts extends React.Component {
  constructor() {
    super()
    this._buildCharts = this._buildCharts.bind(this)
  }

  componentWillMount() {

  }

  componentWillUnmount() {
    this.div = null
    jQuery(window).off('resize orientationchange', this._handleResize)
  }

  componentDidMount() {
    this._buildCharts()
    this._handleResize = utils.throttle(this._buildCharts, 150).bind(this)
    jQuery(window).on('resize orientationchange', this._handleResize)
  }

  componentDidUpdate() {
    this._buildCharts()
  }

  _buildCharts() {
    try{
      if(!this.div) {
        this.div = d3.select('#main-container').append('div')
          .attr('class', 'chart-tooltip')
          .style('opacity', 0)
      }

      // TODO: pick and show appropriate inning comparisons
      const data = selectn('comparison[0]', this.props) || []

      setDataForEmptyOvers(data)

      if(data.length) {
        // Empty containers
        jQuery('#chart-runrate, #chart-manhattan, #chart-worm').html('')
        // TODO: try and update the chart instead of over-writing
        lineChart({ divSelector: '#chart-runrate', data: data, keys: {
          x : 'over',
          y : 'rate'
        }, div: this.div, yLabel: 'RUN RATE' })

        lineChart({ divSelector: '#chart-worm', data: data, keys: {
          x : 'over',
          y : 'totalRuns'
        }, div: this.div, yLabel: 'RUNS' })

        barChart({ div: this.div, data: data })
      }else{
        // hide
        // TODO: use component state to show/hide
        jQuery('#runrate, #manhattan, #worm').hide()
      }
    }catch(e) {
      console.log(e)
    }
  }

  render() {
    const { teams = {}, uiControls = {}, comparison = [] } = this.props
    const data = comparison[0] || []

    teamColors.home = selectn('home.color', teams) || '#40b5e5'
    teamColors.away = selectn('away.color', teams) || '#ef3a49'

    const style =
    `<style>
      svg {
        font-size: 70%;
      }
      .axis path,
      .axis line {
        fill: none;
        stroke: #aaa;
        shape-rendering: crispEdges;
      }
      .x.axis path {
        display: none;
      }
      .line {
        fill: none;
        stroke-width: 3px;
      }
      .tick line {
        stroke: #aaa;
        stroke-dasharray: 3,3;
      }
      .tick text {
        stroke #666
      }
      div.chart-tooltip {
        position: absolute;
        text-align: left;
        padding: 10px;
        border: 0px;
        background: #eee;
        font-size: 80%;
        pointer-events: none;
        max-width: 350px;
    }
    @media screen and (max-width: 1024px) {
      .chart-tooltip {
        display:none
      }
    }
    </style>
    `

    const chartContent = (
      <div>
        <article className="sub-module stats" id="manhattan">
          <header className="bordered">
             <h1>Manhattan</h1>
          </header>
          <div style={{ minHeight: '375px' }} className="content" dangerouslySetInnerHTML={{ __html: '<div id="chart-manhattan" />' }} />
        </article>
        <article className="sub-module stats" id="runrate">
          <header className="bordered">
             <h1>Run rate graph</h1>
          </header>
          <div style={{ minHeight: '375px' }} className="content" dangerouslySetInnerHTML={{ __html: '<div id="chart-runrate" />' }} />
        </article>
        <article className="sub-module stats" id="worm">
          <header className="bordered">
             <h1>Worm</h1>
          </header>
          <div style={{ minHeight: '375px' }} className="content" dangerouslySetInnerHTML={{ __html: '<div id="chart-worm" />' }} />
        </article>
        <div dangerouslySetInnerHTML={{ __html : style }}>
        </div>
      </div>
    )

    return uiControls.showCharts && data.length ? chartContent : <div/>
  }
}



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/Charts.jsx